import { render, staticRenderFns } from "./V2DashboardOrdersList.vue?vue&type=template&id=c46793fa&scoped=true&"
import script from "./V2DashboardOrdersList.vue?vue&type=script&lang=js&"
export * from "./V2DashboardOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./V2DashboardOrdersList.vue?vue&type=style&index=0&id=c46793fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46793fa",
  null
  
)

export default component.exports